import axios from 'axios';
import { apiBaseURL } from '../config/env';

const api = axios.create({
    baseURL: apiBaseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(config => {
    const raw = localStorage.getItem('hotlize_token');
    const token = raw != null ? String(raw).trim() : '';
    if (token && token !== 'undefined') {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


api.interceptors.response.use(
    res => res,
    err => {
        const status = err.response?.status;
        const url = err.config?.url ?? '';
        if (status !== 401 || url.includes('/auth/')) {
            return Promise.reject(err);
        }

        if (url.includes('/auth/refresh')) {
            return Promise.reject(err);
        }

        const refreshToken = localStorage.getItem('hotlize_refresh_token');
        if (refreshToken) {
            return api
                .post<{ success: boolean; access_token?: string; refresh_token?: string }>('/auth/refresh', {
                    refresh_token: refreshToken,
                })
                .then((res) => {
                    if (res.data?.access_token) {
                        localStorage.setItem('hotlize_token', res.data.access_token);
                        if (res.data.refresh_token) {
                            localStorage.setItem('hotlize_refresh_token', res.data.refresh_token);
                        }
                        if (err.config.headers) {
                            err.config.headers.Authorization = `Bearer ${res.data.access_token}`;
                        }
                        return api.request(err.config);
                    }
                    return Promise.reject(err);
                })
                .catch(() => {
                    return Promise.reject(err);
                });
        }

        return Promise.reject(err);
    }
);

export default api;
